import DashboardCard from './DashboardCard';
import useAppData from '@/hooks/use-app-data.hook';
import useQueryHelper from '@/hooks/use-query-helper';
import { PublicServiceMeta } from '@/lib/models/public-service/public-service.model';
import { AppDataQueryKey } from '@/lib/query-client';
import PublicServiceButton from '../public-service-button';
import ScrollBox from '../scroll-box';
import { CircularProgress, Grid, Stack } from '@mui/material';
import { NavigateOptions, useNavigate } from '@tanstack/react-router';
import Button from '../button';

import { useCallback } from 'react';

const DEFAULT_POLICY_LINK = '/config/default-policy';
const PUBLIC_SERVICES_LINK = '/config/public-services';

const Footer = () => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (to: string) => {
      navigate({ to } as NavigateOptions);
    },
    [navigate]
  );
  return (
    <Grid gap={0.5} container width="100%">
      <Grid item lg={5.5} md={12} sm={12}>
        <Button
          size="small"
          icon="policy"
          label="Update Policy"
          fullWidth
          onClick={() => handleClick(DEFAULT_POLICY_LINK)}
        />
      </Grid>
      <Grid item lg={5.5} md={12} sm={12}>
        <Button
          size="small"
          icon="cloud"
          label="View Services"
          type="option"
          fullWidth
          onClick={() => handleClick(PUBLIC_SERVICES_LINK)}
        />
      </Grid>
    </Grid>
  );
};

const RecentPublicServices = () => {
  // TODO: Pending a backend change that will take a date range filter
  const query = useAppData<PublicServiceMeta[]>(AppDataQueryKey.PublicServices);
  const { data = [] } = query;
  const { showLoader } = useQueryHelper(query);

  return (
    <DashboardCard
      title="Recently Added Public Services"
      description={`Stay in the know on our latest public services. Don't forget to update your policies to include these services.`}
      descriptionTooltip={`For the first 30 days, a new policy will fall-back to the 'new-policy action' defined in your default policy if no other policies are defined.`}
      footer={<Footer />}
    >
      <Stack alignItems="center">
        {showLoader ? (
          <CircularProgress />
        ) : (
          <ScrollBox
            max={5}
            emptyMessage="This policy does not grant access to any public services."
          >
            {data.splice(0, 6).map((publicService) => {
              return <PublicServiceButton publicService={publicService} key={publicService.id} />;
            })}
          </ScrollBox>
        )}
      </Stack>
    </DashboardCard>
  );
};

export default RecentPublicServices;
